<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bi8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('cargoList_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('cargoList_add_button') && !parentData.isDetail"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('cargoList_batchSendTax_button')"
          @click="getSelectEvent()"
        >
          批量同步
        </el-button>
        <el-button
          v-if="getLimit('cargoList_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" />
      <!-- <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <!--<vxe-table-column>
        <vxe-table-column min-width="110" field="shipperName" title="发布方姓名" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.shipperName" placeholder="发布方姓名" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column min-width="160" field="shipperIdNo" title="发布方身份证件号码" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.shipperIdNo" placeholder="发布方身份证件号码" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column min-width="130" field="shipperMobile" title="发布方手机号码" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.shipperMobile" placeholder="发布方手机号码" clearable />
        </template>
      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="companyName"
          title="企业名称"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="企业名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="180"
          field="companyPhone"
          title="联系人电话"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyPhone"
            placeholder="联系人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="260"
          field="registerTime"
          title="注册时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.registerTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'registerTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="180"
          field="companyTaxId"
          title="企业纳税人识别号"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyTaxId"
            placeholder="企业纳税人识别号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="legalPerson"
          title="法定代表人"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.legalPerson"
            placeholder="法定代表人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSendTax"
          title="上报状态"
          :formatter="formatterSendStatus"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendTax"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendTaxOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <!-- <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funDesil(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip> -->
          <el-tooltip
            v-if="
              getLimit('cargoList_sendTax_button') && scope.row.isSendTax === 0
            "
            class="item"
            effect="dark"
            content="同步税务信息"
            placement="top"
          >
            <vxe-button type="text" @click="funInfo(scope.row.code)">
              <i class="el-icon-sort" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('cargoList_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('cargoList_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
import { taxShipper, taxShipperTax } from "@/api/Taxation";
export default {
  name: "CargoList",
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      restaurants: [], // 实际承运人列表
      loading: false,
      tableData: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/taxShipper/exportTaxShipper", //导出接口
        name: "托运人信息"
      },
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        branchCode: "lbb03"
      },
      sendTaxOptions: [
        {
          value: "0",
          label: "未上报"
        },
        {
          value: "1",
          label: "已上报"
        },
        {
          value: "2",
          label: "上报失败"
        }
      ]
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.findList();
  },
  methods: {
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要同步的数据", type: "warning" });
      } else {
        var branchCode = "";
        var flag = true;
        for (var i = 0; i < selectRecords.length; i++) {
          branchCode = selectRecords[0].branchCode;
          if (branchCode !== selectRecords[i].branchCode) {
            flag = false;
          }
        }
        if (!flag) {
          this.$message({
            message: "请选择同一机构的托运人信息！",
            type: "error"
          });
        } else {
          const codes = selectRecords.map(item => item.code).join(",");
          this.$confirm("确认上报监管平台吗？").then(_ => {
            const rLoading = this.openLoading();
            request({
              url: "/ntocc-basic-api/taxShipper/taxList",
              method: "put",
              params: { codes: codes }
            })
              .then(response => {
                this.$message.success(response.msg);
                rLoading.close();
              })
              .finally(() => {
                this.$refs.xTable.clearCheckboxRow();
                this.findList();
              });
          });
        }
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterSendStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未上报";
        case 1:
          return "已上报";
        case 2:
          return "上报失败";
        default:
          break;
      }
    },
    // 获取/查询 列表
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        taxShipper(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 排序
    sortList({ column, property, order }) {
      var str = property === "createdByName" ? "createdBy" : property;
      if (order) {
        this.listQuery.sortField = str;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.findList();
    },
    // 新增
    funcAdd() {
      this.$router.push({
        path: "cargoInform",
        query: { code: "" }
      });
    },
    // 详情
    funDesil(code) {
      this.$router.push({
        path: "cargoInform",
        query: { code: code }
      });
    },
    // 编辑
    funcEdit(code) {
      this.$router.push({
        path: "cargoInform",
        query: { code: code }
      });
    },
    // 托运人信息推送
    async funInfo(code) {
      const rLoading = this.openLoading();
      let res = await taxShipperTax({ code });
      rLoading.close();
      this.$message.success(res.msg);
      this.findList();
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          taxShipper({ codes }, "delete").then(response => {
            this.$message.success(response.msg);
            this.findList();
          });
        })
        .catch(_ => {});
    }
  }
};
</script>
